module.exports = __webpack_public_path__ + "statics/img/2.db925aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/technological/2.jpg
// module id = dU4B
// module chunks = 1